import { render, staticRenderFns } from "./NewsComponent.vue?vue&type=template&id=870df596&scoped=true&"
import script from "./NewsComponent.vue?vue&type=script&lang=ts&"
export * from "./NewsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NewsComponent.vue?vue&type=style&index=0&id=870df596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870df596",
  null
  
)

export default component.exports